<template>
    
    <!-- <v-row dense v-for="serieTreino in item.series" :key="serieTreino.id"> -->

    <v-row class="pr-5">
      <v-col cols="11" style="">

        <v-list-item two-line v-if="esporte == 'Corrida'" dense class="pl-0 pt-0">
          <v-list-item-content class="pl-0" >
            <v-list-item-title class="treino-title font-weight-black">
              {{esporte}}<span class="treino-title">{{(serieTreino.repeticoes ? ', ' + serieTreino.repeticoes + 'x' : '')}}</span>
            </v-list-item-title>
             <v-list-item-subtitle v-html="getLinhaFormatadaHTML(esporte, serieTreino)" style="color : rgb(65, 199, 65);">
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-list-item two-line v-if="esporte == 'Ciclismo' && serieTreino.tipoTreino == 'Potência'" dense class="pl-0 pt-0">
          <v-list-item-content class="pl-0">
            <v-list-item-title class="treino-title font-weight-black">
              {{esporte}}<span class="treino-title">{{(serieTreino.repeticoes ? ', ' + serieTreino.repeticoes + 'x' : '')}}</span>
            </v-list-item-title>
            <v-list-item-subtitle v-html="getLinhaFormatadaHTML(esporte, serieTreino)" style="color : rgb(65, 199, 65);">
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-list-item two-line v-if="esporte == 'Ciclismo' && serieTreino.tipoTreino == 'Frequência'" dense class="pl-0 pt-0">
          <v-list-item-content class="pl-0">
            <v-list-item-title class="treino-title font-weight-black">
              {{esporte}}<span class="treino-title">{{(serieTreino.repeticoes ? ', ' + serieTreino.repeticoes + 'x' : '')}}</span>
            </v-list-item-title>
            <v-list-item-subtitle v-html="getLinhaFormatadaHTML(esporte, serieTreino)" style="color : rgb(65, 199, 65);">
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-list-item two-line v-if="esporte == 'Ciclismo' && serieTreino.tipoTreino == 'Pace'" dense class="pl-0 pt-0">
          <v-list-item-content class="pl-0">
            <v-list-item-title class="treino-title font-weight-black">
              {{esporte}}<span class="treino-title">{{(serieTreino.repeticoes ? ', ' + serieTreino.repeticoes + 'x' : '')}}</span>
            </v-list-item-title>
            <v-list-item-subtitle v-html="getLinhaFormatadaHTML(esporte, serieTreino)" style="color : rgb(65, 199, 65);">
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-list-item two-line v-if="esporte == 'Natação'" dense class="pl-0 pt-0">
          <v-list-item-content class="pl-0">
            <v-list-item-title class="treino-title font-weight-black">
              {{esporte}}<span class="treino-title">{{(serieTreino.repeticoes ? ', ' + serieTreino.repeticoes + 'x' : '')}}</span>
            </v-list-item-title>
            <v-list-item-subtitle v-html="getLinhaFormatadaHTML(esporte, serieTreino)" style="color : rgb(65, 199, 65);">
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

      </v-col>

      <v-col cols="1">
        
        <v-btn color="primary" class="mb-n5" text outlined fab x-small v-if="esporte == 'Corrida'">
          <v-icon class="">mdi-run-fast</v-icon>
        </v-btn>
      
        <v-btn color="primary" class="mb-n5" text outlined fab x-small v-if="esporte == 'Ciclismo'">
          <v-icon class="">mdi-bike</v-icon>
        </v-btn>
      
        <v-btn color="primary" class="mb-n5" text outlined fab x-small v-if="esporte == 'Natação'">
          <v-icon class="">mdi-swim</v-icon>
        </v-btn>
        
      </v-col>

    </v-row>

</template>

<script>

//import axios from 'axios';
//import SnackBar from "../snackbar";
import {myMixin} from '../mixin';


export default {
  props: {
    serieTreino : Object,
    esporte : String,
  },

  mixins : [
    myMixin
  ],


  beforeMount () {

    
  },

  data: () => ({
    
  }),

  methods : {

    
  }
};
</script>

<style>

.treino-title{
  color: rgb(65, 199, 65);
}

</style>